// extracted by mini-css-extract-plugin
export var container = "YourInvitesModal-module__container___MxPJk";
export var content = "YourInvitesModal-module__content___Am0YU";
export var heart = "YourInvitesModal-module__heart___HOINT";
export var spacer = "YourInvitesModal-module__spacer___z_uYN";